import { AddEmpresaCommandProps } from "api/Commands/AddEmpresaCommand"
import { TIPO_EMPRESA_USUARIO } from "api/Types/TipoEmpresa"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const adapterNuevaEmpresa = (values: any): AddEmpresaCommandProps => {
  return {
    codigoPais: values.codigoPais,
    direccion: {
      direccion: values.direccion,
      codigoPostal: values.cp,
      poblacionExtranjera: values?.poblacionExtranjera,
      poblacionId: values?.poblacionId,
    },
    nif: values.cif,
    razonSocial:
      values.mode !== TIPO_EMPRESA_USUARIO.AUTONOMO
        ? values?.razonSocial
        : `${values?.nombre} ${values?.apellidos}`,
    tipoEmpresa: values.mode,
  }
}
